<!-- Content Section -->
<div class="container text-center py-5">
  <div class="row program-section heading-section pb-5">
    <div class="heading-1 h4" data-aos="fade-in" data-aos-duration="1000">JOIN TODAY</div>
    <div class="heading-2 h2 pb-5" data-aos="fade-in" data-aos-duration="1000">Gain access to new resources released monthly!</div>
    <div class="col-sm-6 col-lg-3">
      <div class="card" data-aos="fade-right" data-aos-duration="1000">
        <div class="card-header">
          <div class="icon"> <img src="assets/brand/gear.png" height="80%" /> </div>
          <!-- <a href="https://www.flaticon.com/free-icons/dance" title="dance icons">Dance icons created by Freepik - Flaticon</a> -->
        </div>
        <div class="card-body">
          <h6 class="card-title">SKILL LIBRARY</h6>
          <p class="card-text">Thousands of short videos that introduce grips, transitions and drills to help your team be the best on the floor.
          </p>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-lg-3">
      <div class="card" data-aos="zoom-in-up" data-aos-duration="1000">
        <div class="card-header">
          <div class="icon"> <img src="assets/brand/gear.png" height="80%" /> </div>
        </div>
        <div class="card-body">
          <h6 class="card-title">TEAM BUILDING</h6>
          <p class="card-text">Activities that focus on trust, communication, conflict resolution and bringing your team together on the floor.
          </p>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-lg-3">
      <div class="card" data-aos="zoom-in-up" data-aos-duration="1000">
        <div class="card-header">
          <div class="icon"> <img src="assets/brand/gear.png" height="80%" /> </div>
        </div>
        <div class="card-body">
          <h6 class="card-title">RULEBOOKS & LEGALITIES</h6>
          <p class="card-text">Creative elements are sorted by rulebooks including IASF, ICU, USASF & NSHF and include legality reminders.
          </p>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-lg-3">
      <div class="card signature-card" data-aos="fade-left" data-aos-duration="1000">
        <div class="card-header">
          <div class="icon"> <img src="assets/brand/gear.png" height="80%" /> </div>
        </div>
        <div class="card-body">
          <h6 class="card-title">SIGNATURE SERIES</h6>
          <p class="card-text">1:1 instruction from the best in the industry through masterclasses that walk you through their coaching philosophy.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="row video-section heading-section">
    <div class="heading-1 h4" data-aos="fade-in" data-aos-duration="1000">OUR FORGE CLASSES</div>
    <div class="heading-2 h2 pb-3" data-aos="fade-in" data-aos-duration="1000">Checkout our Latest Videos</div>
    <div class="col-sm-12 col-md-4"  *ngFor="let video of videos">
      <img src="{{'assets/images/'+video.video_thumb}}" class="img-thumbnail" alt="" (click)="openDetails(video.id,'staticBackdrop')">
    </div>
    <div class="pt-2 d-inline-block" data-aos="fade-up" data-aos-duration="1000">
      <a class="btn btn-lg btn-gold border-0 px-3" routerLink="/signup">SIGN UP</a>
    </div>
  </div>
</div>
<div class="bg-banner" data-aos="fade-in" data-aos-duration="1000" data-parallax="scroll">
  <div class="container text-center py-5">
    <div class="row background-section back-ground-section">
      <div class="text-gold h3 text-uppercase" data-aos="fade-up" data-aos-duration="1000"> Why Sign Up To Forge?</div>
      <div class="letter-spacing-p pt-4" data-aos="fade-up" data-aos-duration="1000">
        Learn new skills, drills, and techniques that you can apply immediately in practice.
         Find countless options that will work for your athletes and new and creative choreography ideas,
          each with coach notes, legality tips, and more.
      </div>
      <div class="col-sm-6 col-lg-3">
        <div class="card" data-aos="zoom-in-right" data-aos-duration="1000">
          <div class="card-body">
            <div class="card-title h4 m-0">Huge Video Library</div>
          </div>
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src="assets/brand/library.png" class="card-img-bottom" alt="...">
              </div>
              <div class="flip-card-back">
                <i class="fa-solid fa-video text-gold pb-3"></i>
                <p class="card-text">Thousands of videos with more being added every month. <br>
                  Close up on grips, details on athlete movement and slow-motion to make sure you get all the details.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-lg-3">
        <div class="card" data-aos="zoom-in-up" data-aos-duration="1000">
          <div class="card-body">
            <div class="card-title h4 m-0">Rule Book Sorting</div>
          </div>
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src="assets/brand/activity-pose-2.png" class="card-img-bottom" alt="...">
              </div>
              <div class="flip-card-back"> 
                <i class="fa-solid fa-sitemap text-gold pb-3"></i>
                <p class="card-text">Choose the rule book your team uses and each skill video will be sorted into the correct level and include up to date legality information.
                  <br>
                  Current rule books include USASF, IASF, and ICU.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-lg-3">
        <div class="card" data-aos="zoom-in-up" data-aos-duration="1000">
          <div class="card-body">
            <div class="card-title h4 m-0">Easy to Organize</div>
          </div>
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src="assets/brand/activity-pose-3.png" class="card-img-bottom" alt="...">
              </div>
              <div class="flip-card-back">
                <i class="fa-solid fa-cut text-gold pb-3"></i> 
                <p class="card-text">Add your favourite videos to your dashboard and then sort them into shareable and customizable lists however you’d like.
                  <br>
                  Create stunt sequences, collections of skill ideas, whatever you’d like.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-lg-3">
        <div class="card" data-aos="zoom-in-left" data-aos-duration="1000">
          <div class="card-body">
            <div class="card-title h4 m-0">Professional Coaches</div>
          </div>
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src="assets/brand/activity-pose-4.png" class="card-img-bottom" alt="...">
              </div>
              <div class="flip-card-back">
                <i class="fa-solid fa-person-chalkboard text-gold pb-3"></i>  
                <p class="card-text">Our instructors come from the worlds of both Cheerleading and Gymnastics and have lots of experience delivering workshops for both athletes and coaches.
                  <br>
                  Be sure to check out the Signature Series for some tips from the best and brightest.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 


<div class="container text-center" data-aos="fade-up" data-aos-duration="1000">
  <div class="row heading-section team-section py-5">
    <div class="heading-1 h4" data-aos="zoom-in-up" data-aos-duration="1000">OUR FORGE TEAM</div>
    <div class="heading-2 h2 pb-4" data-aos="zoom-in-up" data-aos-duration="1000">Meet some of your instructors</div>
    <div class="col-sm-6 col-lg-3">
      <div class="card border-0" data-aos="zoom-in-left" data-aos-duration="1000">
        <div class="card-body">
          <img class="card-img rounded-circle" src="assets/brand/team-member-4.png" data-aos="zoom-in-up" data-aos-duration="1000">
          <div class="h4 expert-name">
            Pat
          </div>
          <p class="">
            Pat is a gym owner with several national titles who focuses on precision technique and athlete preparation for competition.
          </p>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-lg-3">
      <div class="card border-0" data-aos="zoom-in-up" data-aos-duration="1000">
        <div class="card-body">
          <img class="card-img rounded-circle" src="assets/brand/team-member-2.png" data-aos="zoom-in-up" data-aos-duration="1000">
          <div class="h4 expert-name">
            Chris
          </div>
          <p class="">
            Chris provides choreography and skill building in over 40 countries and supports dozens of international federations in education and governance.
          </p>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-lg-3">
      <div class="card border-0" data-aos="zoom-in-right" data-aos-duration="1000">
        <div class="card-body">
          <img class="card-img rounded-circle" src="assets/brand/team-member-1.png" data-aos="zoom-in-up" data-aos-duration="1000">
          
          <div class="h4 expert-name">
            Bryan
          </div>
          <p class="">
            Bryan has competed on the worlds stage multiple times and currently delivers fast, creative choreography and skill workshops on the international stage.
          </p>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-lg-3">
      <div class="card border-0" data-aos="zoom-in-up" data-aos-duration="1000">
        <div class="card-body">
          <img class="card-img rounded-circle" src="assets/brand/team-member-3.png" data-aos="zoom-in-up" data-aos-duration="1000">
          <div class="h4 expert-name">
            Monika
          </div>
          <p class="">
            Monika is a choreographer and athlete with a focus on athlete performance and flyer technical training.
          </p>
        </div>
      </div>
    </div>
    
  </div>
</div>
<!-- Content Section End -->


<!-- Modal -->
<app-video-details modalid="staticBackdrop" [videoDetails]="videoDetails"></app-video-details>